<tiptap-bubble-menu
  [editor]="editor()"
  [updateDelay]="0"
  [options]="{
    placement: 'left',
    offset: 15,
    strategy: 'fixed',
    flip: false
  }"
  [shouldShow]="shouldShowMenu"
  pluginKey="tableRowMenu"
>
  <div
    role="toolbar"
    class="editor-menu border rounded ml-[calc(100%+2rem)] max-w-min"
  >
    <mat-action-list>
      <button
        (click)="onAddRowBefore()"
        mat-list-item
      >
        Add row before
      </button>
      <button
        (click)="onAddRowAfter()"
        mat-list-item
      >
        Add row after
      </button>
      <button
        (click)="onDeleteRow()"
        mat-list-item
      >
        Delete row
      </button>
    </mat-action-list>
  </div>
</tiptap-bubble-menu>
